import React, { useEffect, useState } from "react";
import "./cardDetails.css";
import "../cards/cards.css";

import coinIcon from "../../../../assets/icon/points.png";
import { useNavigate, useParams } from "react-router-dom";
import authAxios from "../../../../config/authAxios";
import BackArrow from "../../../../assets/svg/BackArrow";
import QuizWallicon from "../../../../assets/svg/QuizWallicon";
import Processing from "../processing";
import { useSelector } from "react-redux";
import ProgressBarNew from "../../theme6/component/ProgressBarNew";


const CardDetails = () => {
  const { id } = useParams();
  const [giftCardInfo, setGiftCardInfo] = useState({})
  const [wallet, setWallet] = useState({})
  const [isProcessing, setIsProcessing] = useState(false)
  const navigate = useNavigate()
  const getAppSelector = useSelector(state => state.getApp)
  const { Config } = getAppSelector
  const fetchCardsInfo = async (e) => {
    try {
      const response = await authAxios.get(`/users/api/giftCardInfo/${id}`);
      setGiftCardInfo(response?.data?.data)
      setWallet(response?.data?.userWallet)

    } catch (error) {
      console.error(error);
    }
  }
  const handlePurchase = async () => {
    try {
      if (wallet?.redemption < giftCardInfo?.price?.denominations[0] * Config?.rup_val) {
        return
      }
      setIsProcessing(true)
      const response = await authAxios.get(`/users/api/purchase/${id}`);
      fetchCardsInfo()
      navigate(`/cardResult/success?message=${response?.data?.message}`)

    } catch (error) {
      console.log(error?.response?.data);
      fetchCardsInfo()
      navigate(`/cardResult/fail?message=${error?.response?.data}`)
    } finally {
      setIsProcessing(false)
    }
  }
  useEffect(() => {
    window.scrollTo(0,0)
    fetchCardsInfo()
  }, [])

  return (
    <>
      {isProcessing ? <Processing /> :
        <div className={"box_container"}>
          <div className={"store_box_container_top"}>
            <div onClick={() => navigate(-1)}>
              <BackArrow />
            </div>
            <QuizWallicon width={143} height={31} />
          </div>
          <div className={"store_box_container"}>
            <h3 className={"st_text1"}>{giftCardInfo?.name}</h3>


            <div className="voucher-card-container">
              <div className="voucher-img">
                <img src={giftCardInfo?.image?.thumbnail} alt="" />
              </div>

              <div className="voucher-desc">
                <div className="desc-head">{giftCardInfo?.name}</div>
                <div className="desc-content" dangerouslySetInnerHTML={{__html : giftCardInfo?.description}} />
                   </div>

              {/* <div className="about-voucher">You get: Rs.300 Amazon balance voucher</div> */}


              <div className="card-progress-content">
                <div className="coin-para">{wallet?.redemption >= giftCardInfo?.price?.denominations[0] * Config?.rup_val ? "0" : giftCardInfo?.price?.denominations[0] * Config?.rup_val - wallet?.redemption} Coins left to redeem gift card</div>


                <ProgressBarNew
                  current={wallet?.redemption || 0}
                  total={giftCardInfo?.price?.denominations[0] * Config?.rup_val}
                  height="16px"
                  backgroundColor="#372e5c"
                  progressColor="#fff8f8"
                  textColor="#fff8f8"
                  progressTextColor="#372e5c"
                  borderRadius="18.57px"
                  textSize="8px"
                />

                <div className="coin-info">
                  <div className="card-coin">
                    <img src={coinIcon} alt="" />
                    <span>{giftCardInfo?.price?.denominations[0] * Config?.rup_val}</span>
                  </div>
                  <p className="coinreq">Coins required</p>
                </div>

                <div className="card-detail-button" onClick={handlePurchase} style={{ opacity: wallet?.redemption >= giftCardInfo?.price?.denominations[0] * Config?.rup_val ? 1 : 0.73 }}>
                  Redeem Gift Card
                </div>

              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default CardDetails;
